/**
 * Sidebar Component
 *
 * Desktop sidebar navigation with collapsible state.
 */

import { SidebarFooter } from './sidebar-footer';
import { SidebarHeader } from './sidebar-header';
import { SidebarNav } from './sidebar-nav';
import type { SidebarProps } from '../../types';
import { cn } from '@/shared/lib';
import { useUIStore } from '@/state/stores/ui.store';

export const Sidebar = ({ className }: SidebarProps) => {
  const { isSidebarCollapsed, toggleSidebarCollapse } = useUIStore();

  return (
    <aside
      className={cn(
        'fixed left-0 top-0 h-screen bg-white dark:bg-neutral-900 border-r border-neutral-200 dark:border-neutral-800 z-40',
        'flex flex-col transition-all duration-300 ease-in-out',
        isSidebarCollapsed ? 'w-[72px]' : 'w-64',
        className
      )}
    >
      <SidebarHeader
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebarCollapse}
      />

      <SidebarNav isCollapsed={isSidebarCollapsed} />

      <SidebarFooter
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebarCollapse}
      />
    </aside>
  );
};

export default Sidebar;
